import React from 'react';
import styles from './Backdrop.module.scss';

const backdrop = props =>
  props.show ? (
    <div className={styles.backdrop} onClick={props.clickHandler} />
  ) : null;

export default backdrop;
